// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3oHC2","select":"Header_select__ZV0qM","clinic":"Header_clinic__1vcuX"};